import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';

const CalendarTitleTextField = ({
  name,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
}) => {
  return (
    <Stack gap={1}>
      <Typography variant="body2">제목</Typography>
      <TextField
        {...{ name, value, onChange, onBlur, error, helperText }}
        disabled={disabled || false}
      />
    </Stack>
  );
};

export default CalendarTitleTextField;
